// extracted by mini-css-extract-plugin
export default {"innerContainer":"SetTeamMemberTags_innerContainer__Iom3Z","saveButton":"SetTeamMemberTags_saveButton__j73he","select":"SetTeamMemberTags_select__ZQ09e"};